export const CODES = {
  down: 40,
  enter: 13,
  esc: 27,
  left: 37,
  right: 39,
  space: 32,
  tab: 9,
  up: 38
} as const;

type CodeKey = keyof typeof CODES;

export function code(key: string): number {
  return CODES[key.toLowerCase() as CodeKey] as number;
}
export function codes(keys: string[]): number[] {
  return keys.map((k) => CODES[k.toLowerCase() as CodeKey]) as number[];
}
